module.exports = __webpack_public_path__ + "img/scene3-7.6f2bea17.jpg";